@if (isVisible) {
  <div id="playerSearchModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">Player Search</div>
        </div>
        <div class="modal-body">
          <div class="search-row">
            <div class="input-group mb-3">
              <input id="searchInput" type="text" class="form-control" style="width: 100%"
                placeholder="Search by player's first or last name" [ngModel]="searchTerm()"
                (ngModelChange)="searchTerm.set($event)" (keydown)="onSearchInputKeydown($event)" />
                <button id="searchButton" class="btn btn-primary" type="button" (click)="filterPlayers()">
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
            </div>
            <div class="mt-3" style="margin-top: 15px;">
              <table class="table table-striped table-hover mt-3">
                <thead>
                  <tr>
                    <th>
                      <app-sortable-header column="lastName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                        Last Name
                      </app-sortable-header>
                    </th>
                    <th>
                      <app-sortable-header column="firstName" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                        First Name
                      </app-sortable-header>
                    </th>
                    <th>
                      <app-sortable-header column="slot.groupNumber" [sortConfig]="sortConfig()" (sort)="onSort($event)">
                        Group
                      </app-sortable-header>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  @for (player of filteredPlayers(); track player) {
                    <tr>
                      <td>{{ player.lastName }}</td>
                      <td>{{ player.firstName }}</td>
                      <td>{{ player.slot?.groupNumber }}</td>
                      <td>
                        <button id="selectPlayerButton" class="btn btn-primary btn-sm" (click)="selectPlayer(player)">
                          <i class="fa fa-external-link"></i>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button id="closeModalButton" type="button" class="btn btn-primary" (click)="closeModal()">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  }